import React, { useState, useEffect } from "react";
import styles from "./BookingRefund.module.css";
import { Accordion, } from "react-bootstrap";
import { Swiper } from "src/components/ui/Swiper.jsx";
import { CURRENCY } from "src/constant/flight-constant.js"
import { useDispatch, useSelector } from "react-redux";
import { updateRefundInsurance } from "src/redux/slices/checkoutSlice.js";
import { formatIndianCurrency } from "src/utils/utils.js";

const options = [
  {
    icon: "/Image/insuranceImages/tigo/booking_img_1.svg",
    label: (
      <>
        Last-minute <br /> Emergency
      </>
    ),
  },
  {
    icon: "/Image/insuranceImages/tigo/booking_img_2.svg",
    label: (
      <>
        Personal <br /> Emergency
      </>
    ),
  },
  {
    icon: "/Image/insuranceImages/tigo/booking_img_3.svg",
    label: (
      <>
        Home <br /> Emergency
      </>
    ),
  },
  {
    icon: "/Image/insuranceImages/tigo/booking_img_4.svg",
    label: (
      <>
        Accident, Illness & <br /> Injury
      </>
    ),
  },
  {
    icon: "/Image/insuranceImages/tigo/booking_img_5.svg",
    label: (
      <>
        Pre-existing <br /> Medical
      </>
    ),
  },
  {
    icon: "/Image/insuranceImages/tigo/booking_img_6.svg",
    label: (
      <>
        Family <br /> Emergency
      </>
    ),
  },
  {
    icon: "/Image/insuranceImages/tigo/booking_img_7.svg",
    label: (
      <>
        Transport <br /> Failure
      </>
    ),
  },
  {
    icon: "/Image/insuranceImages/tigo/booking_img_8.svg",
    label: (
      <>
        Adverse <br /> Weather
      </>
    ),
  },
  {
    icon: "/Image/insuranceImages/tigo/booking_img_9.svg",
    label: (
      <>
        And many <br /> more!
      </>
    ),
  },
]; 
const BookingRefund = ({ priceCheckResponse , passengerInfo}) => {
  const dispatch = useDispatch();
  const { refundInsurance } = useSelector((state) => state.checkoutSlice);
  // Derive selected from Redux so popup upgrades are reflected here
  const [selected, setSelected] = useState("no");
  const currencySymbol = CURRENCY;
  const totalInsurancePax = Number(passengerInfo?.adult || 0) + Number(passengerInfo?.children || 0)

  // Keep local state in sync with Redux
  useEffect(() => {
    setSelected((refundInsurance?.addedAmount || 0) > 0 ? "yes" : "no");
  }, [refundInsurance?.addedAmount]);

  const handleChecked = () => {
      const newSelected = selected === "no" ? "yes" : "no";
      setSelected(newSelected);
      dispatch(updateRefundInsurance({
        addedAmount : newSelected === "yes" ? Number(priceCheckResponse?.refundablePlan?.amount?.toFixed(0)) : 0,
        quantity: 1,
        details :  priceCheckResponse?.refundablePlan,
      }))
  };

  if(!priceCheckResponse?.refundablePlan) return null

  return (
    <>
      <div className={styles?.bookingRefundWrapper + " !shadow-md !rounded-sm"}>
        <Accordion defaultActiveKey="0">
          <Accordion.Item className={styles.bookingRefundItem} eventKey="0">
            <Accordion.Header className={styles?.bookingHeadingWrapper}>
              <div
                  className="absolute top-0 left-0 w-full h-1.5 rounded-t-lg"
                  style={{ backgroundColor: "#8b3393" }}
                ></div>
              <img
                className={styles?.refundLogo}
                src="/Image/insuranceImages/tigo/refund_logo.svg"
                alt="Refund Shield"
              />
              <div className={styles?.uprBookingText}>
                <p className={styles.bookingtxt}>Booking Refundable</p>
                <p className={styles?.uprBadge_1}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    class="baggageInsurance_bagIcon1__3jipD"
                  >
                    <path
                      d="M14.3114 4.6C15.2371 4.6 16 5.392 16 6.4V16.3C16 17.317 15.2371 18.1 14.3114 18.1C14.3114 18.622 13.9086 19 13.4286 19C13 19 12.5714 18.622 12.5714 18.1H7.42857C7.42857 18.622 7 19 6.57143 19C6.09143 19 5.68857 18.622 5.68857 18.1C4.76286 18.1 4 17.317 4 16.3V6.4C4 5.392 4.76286 4.6 5.68857 4.6H7.42857V1.9C7.42857 1.378 7.82286 1 8.28571 1H11.7143C12.1771 1 12.5714 1.378 12.5714 1.9V4.6H14.3114ZM11.2857 4.6V2.35H8.71429V4.6H11.2857ZM6.57143 7.3V15.4H7.85714V7.3H6.57143ZM12.1429 7.3V15.4H13.4286V7.3H12.1429ZM9.35714 7.3V15.4H10.6429V7.3H9.35714Z"
                      fill="white"
                    ></path>
                  </svg>
                  Make my booking refundable
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="9"
                    viewBox="0 0 9 9"
                    fill="#08A20D"
                    className={styles.rightCornerIcon}
                  >
                    <path d="M9 0H0L9 9V0Z" fill="#08A20D"></path>
                  </svg>
                </p>
                <p className={styles?.uprBadge_2}>Recommended</p>
              </div>
              {/* <p className={styles?.bookingHeading}>Secure your Baggage</p> */}
              <p className={styles?.bookingSubHeading}>
                Upgrade to a refundable booking and receive up to 100% refund if
                you need to cancel
              </p>
              <div className={`${styles?.downBaggageIcon} downBaggageIcon`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <path
                    d="M3 15L11 7L19 15"
                    stroke="#DC391B"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </div>
            </Accordion.Header>
            <Accordion.Body className={styles?.bookingAccordianBody}>
              <div className={`${styles.priceBox} ${styles.priceBox1} `}>
                <strong>
                  {currencySymbol}
                  {/* {flatpPriceDecimal(
                    priceCheckResponse?.refundablePlan?.amount
                  )} */}
                  {
                    priceCheckResponse?.refundablePlan?.amount?.toFixed(0)
                  }
                </strong>
                <span>
                  {" "}
                  {currencySymbol}{" "}
                  {formatIndianCurrency(
                    priceCheckResponse?.BookingFlightDetails?.[0]?.fare
                      ?.grandTotal)
                  }{" "}
                  Refundable Value
                </span>
              </div>
              <div className={styles.refundWrapper}>
                <Swiper options={options} />
               

                <div className={styles.bookingboxWrap}>
                  <div className={styles.radioGroup}>
                    <label
                      className={selected === "yes" ? styles.selected : ""}
                    >
                      <input
                        type="radio"
                        name="refund"
                        value="yes"
                        checked={selected === "yes"}
                        onChange={() => handleChecked()}
                      />
                      Yes, make booking refundable
                    </label>
                    <label className={selected === "no" ? styles.selected : ""}>
                      <input
                        type="radio"
                        name="refund"
                        value="no"
                        checked={selected === "no"}
                        onChange={() => handleChecked()}
                      />
                      No, I understand that I may not receive a refund if I need
                      to cancel
                    </label>
                  </div>

                  <div className={styles.priceBox}>
                    <strong>
                      {currencySymbol}{" "}
                      {/* {flatpPriceDecimal(
                        priceCheckResponse?.refundablePlan?.amount
                      ).replace(formattingAmoutRegex, ",")} */}
                      {
                        priceCheckResponse?.refundablePlan?.amount?.toFixed(0)
                     }
                    </strong>
                    <span>
                      {currencySymbol}{" "}
                      {
                        priceCheckResponse?.BookingFlightDetails?.[0]?.fare
                          ?.grandTotal?.toFixed(0)
                      }{" "}
                      Refundable Value
                    </span>
                  </div>
                </div>

                <div className={styles.terms}>
                  <img src="/Image/insuranceImages/tigo/refund_logo.svg" alt="Refund Shield" />
                  <p style={{ marginBottom: "0px" }}>
                    By adding flight refund assurance you agree to the{" "}
                    <a
                      href={
                        priceCheckResponse?.refundablePlan?.refundable_terms_url
                      }
                      target="_blank"
                    >
                      Refund Shield Terms & Conditions
                    </a>
                  </p>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
};

export default BookingRefund;
